import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=a6fc1c82&scoped=true"
import script from "./layout.ts?vue&type=script&lang=ts&external"
export * from "./layout.ts?vue&type=script&lang=ts&external"
import style0 from "./layout.vue?vue&type=style&index=0&id=a6fc1c82&prod&lang=scss"
import style1 from "./layout.vue?vue&type=style&index=1&id=a6fc1c82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6fc1c82",
  null
  
)

export default component.exports